import type { SxProps, Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

export const getHeaderAppBarSx = (theme: Theme): SystemStyleObject<Theme> => ({
  zIndex: theme.zIndex.drawer + 1,
  height: 56,
  backgroundColor: "var(--universal-black)",
  borderBottom: "none",
  color: "var(--text-on-primary)",
  boxShadow: "none",
});

export const headerToolbarSx: SxProps<Theme> = {
  minHeight: "56px !important",
  height: "56px",
  display: "flex",
  justifyContent: "space-between",
  gap: 1.5,
  px: { xs: 2, md: 3 },
};

export const getHeaderIconButtonSx = (theme: Theme): SystemStyleObject<Theme> => ({
  width: 36,
  height: 36,
  minWidth: 36,
  minHeight: 36,
  padding: 0,
  borderRadius: "50%",
  backgroundColor: "var(--button-enabled)",
  color: "var(--text-on-primary)",
  "&:hover": { backgroundColor: "var(--button-hover-focus)" },
  "&:active": { backgroundColor: "var(--button-pressed)" },
});

export const getHeaderActionButtonSx = (theme: Theme, isActive: boolean): SystemStyleObject<Theme> => ({
  minWidth: { xs: 36, sm: "auto" },
  minHeight: 36,
  maxHeight: 36,
  height: 36,
  px: { xs: 1, sm: 1.5 },
  py: 0,
  borderRadius: "var(--button-radius)",
  border: "1px solid var(--button-enabled)",
  backgroundColor: isActive ? "var(--button-pressed)" : "var(--button-enabled)",
  color: "var(--text-on-primary)",
  fontFamily: '"TT Hoves Pro", sans-serif',
  fontSize: "0.875rem",
  lineHeight: "1rem",
  fontWeight: 500,
  letterSpacing: "0.04rem",
  textTransform: "uppercase",
  "&:hover": {
    backgroundColor: "var(--button-hover-focus)",
    borderColor: "var(--button-hover-focus)",
  },
  "&:active": {
    backgroundColor: "var(--button-pressed)",
    borderColor: "var(--button-pressed)",
  },
  "& .MuiButton-startIcon": {
    mr: { xs: 0, sm: 1 },
    ml: 0,
  },
});

export const getHeaderProfileBadgeSx = (theme: Theme): SystemStyleObject<Theme> => ({
  boxSizing: "border-box",
  height: 36,
  minHeight: 36,
  maxHeight: 36,
  px: 1,
  py: 0,
  borderRadius: "var(--button-radius)",
  border: "1px solid var(--button-enabled)",
  backgroundColor: "var(--button-enabled)",
  color: "var(--text-on-primary)",
  transition: "background-color 150ms ease, border-color 150ms ease",
  "&:hover": {
    backgroundColor: "var(--button-hover-focus)",
    borderColor: "var(--button-hover-focus)",
  },
  "&:active": {
    backgroundColor: "var(--button-pressed)",
    borderColor: "var(--button-pressed)",
  },
});

export const getHeaderAvatarSx = (theme: Theme): SystemStyleObject<Theme> => ({
  width: 24,
  height: 24,
  backgroundColor: "transparent",
  color: "var(--text-on-primary)",
  border: "none",
  "& .MuiSvgIcon-root": {
    fontSize: "1.25rem",
  },
});

export const headerProfileNameSx: SxProps<Theme> = {
  display: { xs: "none", sm: "block" },
  maxWidth: 176,
  fontFamily: '"TT Hoves Pro", sans-serif',
  fontSize: "0.8125rem",
  lineHeight: "1rem",
};
